import { render, staticRenderFns } from "./MotorStats.vue?vue&type=template&id=6b8c982f&"
import script from "./MotorStats.vue?vue&type=script&lang=js&"
export * from "./MotorStats.vue?vue&type=script&lang=js&"
import style0 from "./MotorStats.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "MotorStats.vue"
export default component.exports